import React, { useState, useEffect } from 'react';

const calc = {};
const input_types = ['integer', 'string'];
const radio_types = ['boolean'];

export const AddInfoKg = ({ data, initdata, save, close }) => {
  const [data_form, setDataForm] = useState({});
  const [showCheckMRParent, setShowCheckMRParent] = useState(false);
  const [showFAQ, setShowFAQ] = useState(false);

  useEffect(() => {
    setDataForm(initdata);
  }, [initdata]);

  const pushCalc = (key, formula, items) => {
    if (!calc[formula]) calc[formula] = {};
    calc[formula][key] = items;
  };

  const updateCalc = (key, value, newVal) => {
    Object.keys(calc).forEach(formula => {
      Object.keys(calc[formula]).forEach(key_f => {
        if (calc[formula][key_f].includes(key)) {
          if (formula === "sum") {
            newVal[key_f] = calc[formula][key_f].reduce((acc, cur) => {
              if (cur !== key) {
                return acc + (+(data_form[cur] || 0));
              } else {
                return acc + +value;
              }
            }, 0);
          }
        }
      });
    });
    return newVal;
  };

  const updateField = (pos, value) => {
    const newVal = { ...data_form };
    newVal[pos] = +value;
    if (!isNaN(newVal[pos])) {
      setDataForm(updateCalc(pos, value, newVal));
    }
  };

  const updateFieldBoolean = (pos, e) => {
    const value = e.target.id;
    const newVal = { ...data_form };
    newVal[pos] = value.slice(7, 10) === 'yes';
    setDataForm(newVal);
  };

  const { title, properties } = data;
  const prep_rows = [];

  Object.keys(properties).forEach(key => {
    const row = [];
    row.push(properties[key]['title']);
    row.push(key);
    row.push(properties[key]['type']);
    row.push(properties[key]['enum'] || null);
    row.push(properties[key]['enumNames'] || null);
    
    if (properties[key].hasOwnProperty('result')) {
      row.push(properties[key]['result']['formula']);
      row.push(properties[key]['result']['items']);
      pushCalc(key, properties[key]['result']['formula'], properties[key]['result']['items']);
    }
    
    prep_rows.push(row);
    
    if (properties[key] && properties[key]['properties']) {
      Object.keys(properties[key]['properties']).forEach(key_l => {
        const data_r = properties[key]['properties'][key_l];
        const row_l = [];
        row_l.push(data_r['title']);
        row_l.push(key_l);
        row_l.push(data_r['type']);
        if (data_r.hasOwnProperty('formula')) row_l.push(data_r['formula']);
        prep_rows.push(row_l);
      });
    }
  });

  return (
    <div>
      <div className="table-responsive__1__label">{title}</div>
      <div className="table-responsive__1">
        <table className="table table-striped">
          <tbody>
            <tr></tr>
            {prep_rows.map((row, index) => (
              <tr key={index}>
                <td>{row[0]}</td>
                <td>{row[1]}</td>
                {!row[5] && !row[3] && input_types.includes(row[2]) && (
                  <td>
                    <input
                      onChange={(e) => updateField(row[1], e.target.value)}
                      value={data_form[row[1]] || ''}
                    />
                  </td>
                )}
                {!row[5] && row[3] && input_types.includes(row[2]) && (
                  <td>
                    <select value={data_form[row[1]] || ''} onChange={(e)=>updateField(row[1], e.target.value)}>
                      {row[3].map((k,i)=><option value={k}>{row[4] && row[4][i] || k}</option>)}
                    </select>
                  </td>
                )}
                {!row[5] && radio_types.includes(row[2]) && (
                  <td>
                    <div>
                      <input
                        type="radio"
                        id={'choice_yes' + row[1]}
                        name={'sel__' + row[1]}
                        onChange={(e) => updateFieldBoolean(row[1], e)}
                        checked={data_form[row[1]] === true || data_form[row[1]] === 1}
                      />
                      <label htmlFor={'choice_yes' + row[1]}>Так</label>
                      <input
                        type="radio"
                        id={'choice_no' + row[1]}
                        name={'sel__' + row[1]}
                        onChange={(e) => updateFieldBoolean(row[1], e)}
                        checked={data_form[row[1]] === false || data_form[row[1]] === 0}
                      />
                      <label htmlFor={'choice_no' + row[1]}>Ні</label>
                    </div>
                  </td>
                )}
                {!!row[5] && <td>{data_form[row[1]]}</td>}
              </tr>
            ))}
            <tr></tr>
          </tbody>
        </table>
      </div>
      <div class="justify-content-between modal-footer">
        <div>
            <button type="button" class="btn btn-primary" onClick={() => save(data_form)}>Зберегти</button>
        </div>
    </div>

    </div>
  );
};